import React, { useState } from 'react';

import type { TagEntity } from '@schibsted/frapi-schema';

import { FilterButton } from './FilterButton.js';

interface FilterCloudProps {
  activeFilters: TagEntity[];
  setFilter: (tag: TagEntity) => void;
  filters: TagEntity[];
  isCheckbox?: boolean;
}

const LIMIT = 10;

export const FilterCloud: React.FC<FilterCloudProps> = ({
  filters,
  activeFilters,
  setFilter,
  isCheckbox,
}) => {
  const shouldSlice = filters.length >= LIMIT;
  const [showAll, setShowAll] = useState(shouldSlice);

  return (
    <div>
      <div>
        {filters.slice(0, showAll ? LIMIT : filters.length).map((t) => (
          <FilterButton
            key={t.id}
            tag={t}
            handleClick={setFilter}
            active={activeFilters.some((f) => f.id === t.id)}
            isCheckbox={isCheckbox}
          />
        ))}
      </div>
      {shouldSlice && (
        <button
          className="show-more-filters-button"
          onClick={() => setShowAll(!showAll)}
        >{`${showAll ? '+' : '-'} Vis ${showAll ? 'alle' : 'færre'}`}</button>
      )}
    </div>
  );
};
